module.exports = __webpack_public_path__ + "static/media/SweetPea_Purple_SideviewStem_BH_LR_RGB_0.4cf6b77c.jpg";